<p
  class="business-rating-{{ type }}"
  [attr.data-business-rating]="businessRating"
>
  {{ prefix }}{{ businessRating }}
</p>
